import { atom } from 'jotai';
import { DataLockerSelectedTab } from '@/types/tabs';

export const dataLockerLandingPageSelectedTabAtom = atom<DataLockerSelectedTab>(DataLockerSelectedTab.PLAYER);
